import styled from '@emotion/styled'
import { Text, Container } from 'theme-ui'

import { WithTheme } from '../../../setup'
import media from '../../../common/MediaQueries'

export const DownloadPlatformsStyled = styled.div<WithTheme>`
  background-color: ${({ theme }) => theme.colors.grayLight};
`

export const DownloadPlatformsInnerStyled = styled(Container)<WithTheme>`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${media.phone} {
    flex-direction: row;
    max-width: 77.625rem;
  }
`

export const DownloadPlatformsTitleStyled = styled(Text)<WithTheme>`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-align: center;
  @media ${media.phone} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'text-align: right;' : 'text-align: left;')}
  }
`

export const DownloadPlatformsSubitleStyled = styled(Text)<WithTheme>`
  margin: 1.5rem auto 0;
  max-width: 16.25rem;
  text-align: center;
  @media ${media.phone} {
    max-width: 100%;
    margin: 0.5rem 0 0;
    ${({ theme }) => (theme.direction === 'rtl' ? 'text-align: right;' : 'text-align: left;')}
  }
`

export const DownloadPlatformsContentStyled = styled.div<WithTheme>`
  display: flex;
  flex-direction: column;
  @media ${media.phone} {
    width: 39%;
    max-width: 29.25rem;
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-right: 0; padding-left: 2rem;' : 'padding-right: 2rem; padding-left: 0;')}
  }
`

export const DownloadPlatformsListStyled = styled.div<WithTheme>`
  margin-top: 4rem;

  @media ${media.phone} {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    margin-top: 0;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-right: 2rem; padding-left: 0;' : 'padding-right: 0; padding-left: 2rem;')}
    ${({ theme }) =>
      theme.direction === 'rtl' ? `border-right: 1px solid ${theme.colors.gray};` : `border-left: 1px solid ${theme.colors.gray};`}
  }
`
